<i18n>
{
  "nl-BE": {
    "session_expiry_warning": {
        "text": "Uw sessie zal aflopen in {countdown} seconden.",
        "cta": "Verleng sessie"
    }
  },
  "en-BE": {
    "session_expiry_warning": {
        "text": "Your session will expire in {countdown} seconds.",
        "cta": "Continue session"
    }
  },
  "fr-BE": {
    "session_expiry_warning": {
        "text": "Votre session va expirer dans {countdown} secondes.",
        "cta": "Continuer la session"
    }
  }
}
</i18n>

<template>
    <div id="app">
        <navbar
            ref="navbar"
            :email="$store.state.auth.email"
            :fixed="$route.name === 'report'"
        ></navbar>
        <router-view />
        <ribbon v-if="$store.state.auth.showTimeoutRibbon" type="is-warning">
            {{ $t('session_expiry_warning.text', { countdown: state.countdown }) }}
            <b-button @click="refreshJwt">
                {{ $t('session_expiry_warning.cta') }}
            </b-button>
        </ribbon>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/shared/plugins/axios'
import utils from '@/shared/plugins/utils'

import Navbar from './components/Navbar.vue'
import Ribbon from '@/shared/components/Ribbon.vue'
import { localeMixin } from '@/components/mixins/locale.js'

export default {
    components: {
        navbar: Navbar,
        ribbon: Ribbon,
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Rock.estate Valuation App',
        // all titles will be injected into this template
        // titleTemplate: '%s | Rockestate estimator',
    },
    data() {
        return {
            state: {
                countdown: null,
                countdownInterval: null,
            },
        }
    },
    watch: {
        '$store.state.auth.showTimeoutRibbon'(val) {
            if (val === true) {
                this.startCountdown()
            } else {
                clearInterval(this.state.countdownInterval)
            }
        },
    },
    mounted() {
        console.log('Rockestate app ' + process.env.VUE_APP_VERSION)
        // Check that the frontend verion matches what the backend thinks it should be
        // If it doesn't, refresh with the url containing the version number
        // This should defeat aggressive corporate caches.
        if (process.env.VUE_APP_AUTOREFRESH_STALE_FRONTEND.toLowerCase() === 'true') {
            axios
                .get(utils.urlJoin(process.env.VUE_APP_AUTH_API_URL, 'user'), {
                    params: { frontend_version: process.env.VUE_APP_VERSION_FULL },
                })
                .then(function(response) {
                    let frontend_version = response.data.frontend_version
                    if (
                        frontend_version &&
                        // Using numeric localCompare to get v1.2.0-8 < v1.2.0-10 < v2 < v10

                        frontend_version.localeCompare(
                            process.env.VUE_APP_VERSION_FULL,
                            'en',
                            { numeric: true }
                        ) === 1
                    ) {
                        console.warn(
                            `current frontend version ${process.env.VUE_APP_VERSION_FULL}` +
                                ` expecting ${frontend_version}`
                        )
                        if (window.location.toString().indexOf(frontend_version) === -1) {
                            console.warn(` ==> refreshing`)
                            window.location.replace(
                                [
                                    location.protocol,
                                    '//',
                                    location.host,
                                    location.pathname,
                                    '?v=',
                                    frontend_version,
                                ].join('') // https://stackoverflow.com/a/5817566
                            )
                        } else {
                            console.warn(' version mismatch, even after refresh')
                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }

        if (this.$store.state.auth.showTimeoutRibbon) {
            this.startCountdown()
        }
    },
    methods: {
        find_cookie(cname) {
            var name = cname + '='
            var ca = document.cookie.split(';')
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i]
                while (c.charAt(0) == ' ') {
                    c = c.substring(1)
                }
                if (c.indexOf(name) == 0) {
                    var cookie_value = c.substring(name.length, c.length)
                    return cookie_value
                }
            }
            return null
        },
        set_cookie(cname, cvalue, exdays) {
            var d = new Date()
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
            var expires = 'expires=' + d.toUTCString()
            document.cookie = cname + '=' + cvalue + '; ' + expires + '; Path=/;'
        },
        refreshJwt() {
            this.$store.dispatch('auth/refresh_token')
        },
        startCountdown() {
            const self = this
            const jwt_ = utils.getCookie('re-jwt')
            console.log(jwt_)
            if (jwt_ && jwt_ !== '') {
                const parsed_ = utils.parseJwt(jwt_)
                console.log(parsed_)
                const { exp } = parsed_
                self.state.countdown = exp - Math.round(Date.now() / 1000)
            }
            this.state.countdownInterval = setInterval(() => {
                const jwt_ = utils.getCookie('re-jwt')
                if (jwt_ && jwt_ !== '') {
                    const parsed_ = utils.parseJwt(jwt_)
                    const { exp } = parsed_
                    self.state.countdown = exp - Math.round(Date.now() / 1000)
                }
            }, 1000)
        },
    },
}
</script>

<style lang="scss">
h1,
h2,
h3 {
    font-family: 'Montserrat', sans-serif;
}

#app {
    -webkit-print-color-adjust: exact;
    min-height: 100vh;
}
</style>
